import * as React from 'react'
import clx from 'classnames'

import { Spinner } from './Spinner'

type Props = {
  children?: React.ReactNode
  className?: string
  hideSpinner?: boolean
  position?: 'static' | 'relative' | 'absolute' | 'fixed'
  shadow?: boolean
  spinnerClassName?: string
  size?: 'sm' | 'md' | 'lg' | number
  text?: React.ReactNode
  textClassName?: string
  textPosition?: 'top' | 'bottom' | 'left' | 'right'
  fill?: boolean
  fullScreen?: boolean
}

export const Loader = ({
  textPosition,
  text,
  children,
  position = 'static',
  className,
  hideSpinner,
  shadow,
  spinnerClassName,
  size = 'md',
  textClassName,
  fill,
  fullScreen,
}: Props) => (
  <div
    className={clx(
      'tw-flex tw-items-center tw-justify-center tw-gap-4',
      position !== 'static' && `tw-${position}`,
      shadow &&
        'tw-rounded-lg tw-bg-white/80 tw-shadow-xl tw-backdrop-blur-sm',
        {
          'tw-flex-col': textPosition === 'top',
        },
      fill && 'tw-h-full tw-w-full',
      fullScreen && 'tw-h-screen tw-w-screen',
      className,
    )}
    data-test-id="ui-loader"
  >
    {!hideSpinner && <Spinner className={spinnerClassName} size={size} />}
    {text && (
      <div className={clx('tw-text tw-text-content-base', textClassName)}>
        {text}
      </div>
    )}
    {children}
  </div>
)
